import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NCmsPdpTrustMessagesModal } from './pdp-trust-messages-modal.component';

interface IPdpTrustMessagesBlockDataContent {
    image: string;
    copyLink?: string;
    ctaText?: string;
    showCta?: boolean;
}

@Component({
    selector: 'pdp-trust-messages',
    templateUrl: './pdp-trust-messages.html',
    standalone: true,
    imports: [TranslationModule, HrefComponent, ImageModule, ICmsClientModule, CommonModule]
})
@ICmsComponent<PdpTrustMessagesComponent>({
    id: 'pdp-trust-messages',
    block: {
        url: 'pdp-trust-messages'
    },
    onDemandOnly: true,
    name: 'Pdp Trust Messages',
    description: 'Pdp Trust Messages',
    fields: [
        { key: 'image', type: NICmsContentField.EFieldType.image, title: 'Image', required: true },
        { key: 'copyLink', type: NICmsContentField.EFieldType.text, title: 'Copy link' },
        { key: 'ctaText', type: NICmsContentField.EFieldType.text, title: 'CTA Text' },
        { key: 'showCta', type: NICmsContentField.EFieldType.checkbox, title: 'Show CTA' }
    ]
})
export class PdpTrustMessagesComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    content?: IPdpTrustMessagesBlockDataContent;

    findOutMoreModalId = NCmsPdpTrustMessagesModal.BLOCK_ID;

    @Input()
    variant?: string;
}
